import React, { useState, lazy, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@mui/styles';
import { Box as MuiBox, Avatar as MuiAvatar } from '@mui/material';
import { Field, useForm } from 'react-final-form';

import CropEditor from 'components/ImageCropEditor/CropEditor';
import { IconButton, Icon } from 'components/ui';
const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(14),
    height: theme.spacing(14),
  },
}));

const SIconButton = styled(IconButton)`
  && {
    background-color: inherit;
    width: 100px;
    font-size: 12px;
    margin: 0 5px;
    .MuiChip-icon {
      margin-left: 0;
      margin-right: 5px;
    }
  }
`;

const Upload = ({ sx = { width: 120, height: 120 }, style, name, viewOnly = false }) => {
  const { t } = useTranslation();

  const [file, setFile] = useState();
  const [open, setOpen] = useState(false);

  const form = useForm();

  const classes = useStyles();

  const onDelete = (e) => {
    e.stopPropagation();
    setFile(null);
    form.change(name, null);
  };

  const handleFile = (value) => {
    setFile(value);
    form.change(name, value);
  };

  return (
    <MuiBox display="flex" justifyContent="center" width="100%" style={style}>
      <Field name={name}>
        {({ input }) => {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <MuiBox position="relative" data-id="open-upload-avatar-dialog">
                <MuiAvatar
                  alt="avatar"
                  src={
                    file
                      ? file.preview
                      : typeof input.value === 'string'
                      ? input.value
                      : input.value?.preview
                  }
                  style={sx}
                />
              </MuiBox>

              {!viewOnly && (file && file.preview ? (
                <div
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <SIconButton
                    icon="pen"
                    label={t('Edit')}
                    onClick={() => setOpen(true)}
                  />
                  <SIconButton
                    icon="trash"
                    color="error"
                    label={t('Delete')}
                    onClick={onDelete}
                  />
                </div>
              ) : input.value ? (
                <div
                  style={{
                    gap: 10,
                    marginTop: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <SIconButton
                    icon="pen"
                    label={t('Edit')}
                    onClick={() => setOpen(true)}
                  />
                  <SIconButton
                    icon="trash"
                    color="error"
                    label={t('Delete')}
                    onClick={onDelete}
                  />
                </div>
              ) : (
                <div
                  style={{
                    width: 160,
                    marginTop: '10px',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <SIconButton
                    icon="camera"
                    label={t('Add profile picture')}
                    onClick={() => setOpen(true)}
                  />
                </div>
              ))}
            </div>
          );
        }}
      </Field>
      {open ? (
        <CropEditor
          open={open}
          onClose={() => setOpen(false)}
          file={file}
          setFile={handleFile}
        />
      ) : (
        ''
      )}
    </MuiBox>
  );
};

export default Upload;
